import { chain, sortBy } from 'lodash';
import { Position } from '@turf/helpers';
import { Talhao } from '../@types';
import { LIST_COLORS, getRandomColor } from '../utils/map-colors';
import { RecomendacaoSemeaduraCultivarToSave } from './recomendacoes-semeadura';

export type MapSubtitles = {
  descricao: string;
  cor: string;
};

class RecomendacaoSemeaduraMapa {
  private cultivares: RecomendacaoSemeaduraCultivarToSave[];

  private cultivarColors: Record<string, string> = {};

  constructor(cultivares: RecomendacaoSemeaduraCultivarToSave[]) {
    this.cultivares = cultivares;
  }

  getPolygonsCoordinates(coordinates?: Position[][]) {
    if (!coordinates) return [];

    return coordinates.map((coordinate) =>
      coordinate.map((position) => {
        const latitude = position[1];
        const longitude = position[0];
        return new google.maps.LatLng(latitude, longitude);
      }),
    );
  }

  getCultivaresTalhao(talhaoId: number) {
    return chain(this.cultivares)
      .reduce<number[]>((cultivaresList, { glebaId, itemEstoque }) => {
        if (talhaoId === glebaId && itemEstoque) {
          cultivaresList.push(itemEstoque.id);
        }
        return cultivaresList;
      }, [])
      .sort()
      .join('|')
      .value();
  }

  getCorTalhao(talhaoId: number) {
    const glebaCultivares = this.getCultivaresTalhao(talhaoId);
    if (this.cultivarColors[glebaCultivares]) {
      return this.cultivarColors[glebaCultivares];
    }

    const size = Object.keys(this.cultivarColors).length;

    if (size <= LIST_COLORS.length - 1) {
      this.cultivarColors[glebaCultivares] = LIST_COLORS[size];
    } else {
      const colors = Object.values(this.cultivarColors);
      this.cultivarColors[glebaCultivares] = getRandomColor(colors);
    }

    return this.cultivarColors[glebaCultivares];
  }

  getLegendas(talhoes: Talhao[]) {
    const mapSubtitles: MapSubtitles[] = [];

    talhoes.forEach(({ id }) => {
      const glebaCultivares = this.getCultivaresTalhao(id);
      const color = this.cultivarColors[glebaCultivares];

      const label = this.cultivares
        .reduce<string[]>((names, { itemEstoque }) => {
          glebaCultivares.split('|').forEach((item) => {
            if (!itemEstoque) return names;

            if (names.includes(itemEstoque.descricao)) {
              return names;
            }

            if (+item === itemEstoque.id) {
              names.push(itemEstoque.descricao);
            }
          });
          return names;
        }, [])
        .sort()
        .join(', ');

      if (
        color &&
        label &&
        !mapSubtitles.some((legenda) => legenda.descricao === label)
      ) {
        mapSubtitles.push({
          descricao: label,
          cor: color,
        });
      }
    });

    return sortBy(mapSubtitles, 'descricao');
  }
}

export default RecomendacaoSemeaduraMapa;
